import { render, staticRenderFns } from "./permit.vue?vue&type=template&id=5c586c7a&scoped=true&"
import script from "./permit.vue?vue&type=script&lang=ts&"
export * from "./permit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c586c7a",
  null
  
)

export default component.exports